import axios from "axios";

const apiActivDoc = {
	async readActDoc(idUser) {           
		const response = await axios.get("/api/activdoc/"+idUser);  
		return response.data;        
	},
	async createActDoc(requestData) {
		const response = await axios.post("/api/activdoc", requestData);
		return response.data;
	},
	async updateActDoc(idAD, requestData) {
		const response = await axios.put("/api/activdoc/"+idAD, requestData);
		return response.data;
	},
	async deleteActDoc(idAD) {
		const response = await axios.delete("/api/activdoc/"+idAD);
		return response.data;
	}
};

export default apiActivDoc;
